import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

import {
  PesvViasInspeccionesService,
  PesvViasInspecciones,
  PesvViasInspeccionesPayload,
} from '../../../../../../shared/services/pesv-vias-inspecciones.service';
import { PesvViasZonas, PesvViasZonasService } from '../../../../../../shared/services/pesv-vias-zonas.service';
import { PesvViasInternasService } from '../../../../../../shared/services/pesv-vias-internas.service';
import { PesvViasRiesgosService } from '../../../../../../shared/services/pesv-vias-riesgos.service';
import { PropietarioService } from '../../../../../../shared/services/propietarios.service';
import { Utils } from '../../../../../../shared/utils/Utils';
import { TipoInspeccionService } from '../../../../../../shared/services/tipo-inspeccion.service';
import { TipoMotivoService } from '../../../../../../shared/services/tipoMotivo.service';
import { CondicionesClimaticasService } from '../../../../../../shared/services/condiciones-climaticas.service';
import { CondicionesOperacionService } from '../../../../../../shared/services/condicionesOperacion.service';
import { ResultadoService } from '../../../../../../shared/services/resultado.service';

@Component({
  selector: 'app-vias-inspecciones',
  templateUrl: './vias-inspecciones.component.html',
  styleUrls: ['./vias-inspecciones.component.scss'],
})
export class ViasInspeccionesComponent implements OnInit {
  form!: FormGroup;
  guardando = false;
  idInspeccion: number | null = null;
  activeTab = 1;
  cargandoListado = false;
  editando = false;
  inspecciones: PesvViasInspecciones[] = [];
  inspeccionesFiltradas: PesvViasInspecciones[] = [];
  filtro = '';
  page = 1;
  pageSize = 10;
  readonly Number = Number;

  // Zona sobre la que se registran las inspecciones (llega por la ruta :id)
  zonaId!: number;
  zonaActual: any = null;

  // Catálogos
  viasTodas: any[] = [];
  riesgosDeZona: any[] = [];
  colaboradores: any[] = [];
  cargandoColaboradores = false;

  opcionesCondicionesClimaticas: any[] = [];
  opcionesCondicionesOperacion: any[] = [];
  tiposInspeccion: any[] = [];
  tiposMotivo: any[] = [];
  resultados: any[] = [];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private inspeccionesService: PesvViasInspeccionesService,
    private zonasService: PesvViasZonasService,
    private viasService: PesvViasInternasService,
    private riesgosService: PesvViasRiesgosService,
    private propietarioService: PropietarioService,
    private tipoInspeccionService: TipoInspeccionService,
    private tipoMotivoService: TipoMotivoService,
    private condicionesClimaticasService: CondicionesClimaticasService,
    private condicionesOperacionService: CondicionesOperacionService,
    private resultadoService: ResultadoService,
  ) {}

  ngOnInit(): void {
    this.zonaId = Number(this.route.snapshot.paramMap.get('id'));
    this.inicializarForm();
    this.getZonaActual();
    this.getVias();
    this.getRiesgosDeZona();
    this.getColaboradores();
    this.cargarInspecciones();
    this.cargarTiposInspeccion();
    this.cargarTiposMotivo();
    this.cargarCondicionesClimaticas();
    this.cargarCondicionesOperacion();
    this.cargarResultados();
  }

  // Carga la zona actual para fijarla en el formulario y mostrarla en el breadcrumb
  getZonaActual(): void {
    this.zonasService.getById(this.zonaId).subscribe({
      next: (zona: any) => {
        this.zonaActual = zona?.data ?? zona;
        this.form.patchValue({
          via_id: this.idCatalogo(this.zonaActual?.via_id),
          zona_id: this.zonaId,
        });
      },
      error: () => this.toastError('No se pudo cargar la información de la zona.'),
    });
  }

  getVias(): void {
    this.viasService.getActiveVias().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta) ? respuesta : respuesta?.data;
        this.viasTodas = (Array.isArray(lista) ? lista : []).map((via: any) => ({
          ...via,
          nombreConCodigo: `${via.codigo ?? ''} - ${via.nombre ?? ''}`.trim(),
        }));
      },
      error: () => this.toastError('No se pudieron cargar las vías internas.'),
    });
  }

  // Riesgos ya registrados en esta zona, para asociarlos opcionalmente a la inspección
  getRiesgosDeZona(): void {
    this.riesgosService.getByIdZonas(this.zonaId).subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta) ? respuesta : respuesta?.data;
        this.riesgosDeZona = Array.isArray(lista) ? lista : [];
      },
      error: () => this.toastError('No se pudieron cargar los riesgos de la zona.'),
    });
  }

  getColaboradores(): void {
    this.cargandoColaboradores = true;
    this.propietarioService.getPlanAccion().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta) ? respuesta : respuesta?.data;
        this.colaboradores = (Array.isArray(lista) ? lista : []).map((colaborador: any) => ({
          ...colaborador,
          nombreConCargo: `${colaborador.nombreCompleto?.trim() || 'Sin nombre'} - (${colaborador.cargoData?.cargos || 'Sin cargo'})`,
        }));
        this.cargandoColaboradores = false;
      },
      error: () => {
        this.colaboradores = [];
        this.cargandoColaboradores = false;
        this.toastError('No se pudieron cargar los colaboradores.');
      },
    });
  }

  cargarTiposInspeccion(): void {
    this.tipoInspeccionService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta) ? respuesta : respuesta?.data;
        this.tiposInspeccion = Array.isArray(lista) ? lista : [];
      },
      error: () => this.toastError('No se pudieron cargar los tipos de inspección.'),
    });
  }

cargarTiposMotivo(): void {
    this.tipoMotivoService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta) ? respuesta : respuesta?.data;
        this.tiposMotivo = Array.isArray(lista) ? lista : [];
      },
      error: () => this.toastError('No se pudieron cargar los tipos de motivo.'),
    });
  }

  cargarCondicionesClimaticas(): void {
    this.condicionesClimaticasService.getAllCondicionesClimaticasActivas().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta) ? respuesta : respuesta?.data;
        this.opcionesCondicionesClimaticas = Array.isArray(lista) ? lista : [];
      },
      error: () => this.toastError('No se pudieron cargar las condiciones climáticas.'),
    });
  }

  cargarCondicionesOperacion(): void {
    this.condicionesOperacionService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta) ? respuesta : respuesta?.data;
        this.opcionesCondicionesOperacion = Array.isArray(lista) ? lista : [];
      },
      error: () => this.toastError('No se pudieron cargar las condiciones de operación.'),
    });
  }

  cargarResultados(): void {
    this.resultadoService.getAll().subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta) ? respuesta : respuesta?.data;
        this.resultados = Array.isArray(lista) ? lista : [];
      },
      error: () => this.toastError('No se pudieron cargar los resultados.'),
    });
  }

  nombreVia(id: any): string {
    const via = this.viasTodas.find((item) => String(item.id) === String(id));
    return via?.nombreConCodigo ?? '';
  }

  nombreInspector(id: any): string {
    if (id == null) return '';
    const colaborador = this.colaboradores.find((item) => String(item.cedula) === String(id));
    return colaborador?.nombreCompleto ?? '';
  }

  claseResultado(resultado: any): string {
    switch (resultado) {
      case 'CONFORME': return 'bg-success';
      case 'NO CONFORME': return 'bg-danger';
      case 'CONFORME CON OBSERVACIONES': return 'bg-warning text-dark';
      default: return 'bg-secondary';
    }
  }

  volver(): void {
    this.router.navigate(['listado/vias-zonas']);
  }

  // ===== Listado =====

  cargarInspecciones(): void {
    if (this.cargandoListado) return;

    this.cargandoListado = true;
    this.inspeccionesService.getInspeccionZona(this.zonaId).subscribe({
      next: (respuesta: any) => {
        const lista = Array.isArray(respuesta) ? respuesta : respuesta?.data;
        this.inspecciones = (Array.isArray(lista) ? lista : []).filter(
          (inspeccion: any) => String(inspeccion.zona_id) === String(this.zonaId),
        );
        this.aplicarFiltro();
        this.cargandoListado = false;
      },
      error: () => {
        this.inspecciones = [];
        this.inspeccionesFiltradas = [];
        this.cargandoListado = false;
        this.toastError('No se pudieron cargar las inspecciones registradas.');
      },
    });
  }

  aplicarFiltro(): void {
    const termino = this.filtro.trim().toLowerCase();
    this.inspeccionesFiltradas = this.inspecciones.filter((inspeccion) => {
      if (!termino) return true;
      return [inspeccion.codigo, inspeccion.tipo_inspeccion, inspeccion.resultado, inspeccion.observaciones]
        .some((valor) => String(valor ?? '').toLowerCase().includes(termino));
    });
    this.page = 1;
  }

  mostrarListado(): void {
    if (this.activeTab === 2) return;
    this.activeTab = 2;
  }

  // ===== Edición =====

  editarInspeccion(inspeccion: PesvViasInspecciones): void {
    if (!inspeccion?.id) return;
    this.inspeccionesService.getById(inspeccion.id).subscribe({
      next: (respuesta: any) => {
        const datos = respuesta?.data ?? respuesta;
        this.idInspeccion = Number(datos.id ?? inspeccion.id);
        this.editando = true;

        this.form.patchValue({
          via_id: this.idCatalogo(this.zonaActual?.via_id),
          zona_id: this.zonaId,
          riesgo_id: this.idCatalogo(datos.riesgo_id),
          codigo: datos.codigo,
          tipo_inspeccion: datos.tipo_inspeccion,
          motivo: datos.motivo,
          fecha_inspeccion: this.normalizarFecha(datos.fecha_inspeccion),
          inspector_id: datos.inspector_id,
          condiciones_climaticas: datos.condiciones_climaticas,
          condiciones_operacion: datos.condiciones_operacion,
          resultado: datos.resultado,
          observaciones: datos.observaciones,
          estado: datos.estado ?? 1,
        });
        this.activeTab = 1;
      },
      error: () => this.toastError('No se pudo cargar la inspección para editar.'),
    });
  }

  nuevaInspeccion(): void {
    this.idInspeccion = null;
    this.editando = false;
    this.form.reset(this.valoresIniciales());
    this.activeTab = 1;
  }

  cambiarEstado(inspeccion: PesvViasInspecciones): void {
    if (!inspeccion.id) return;
    const activar = Number(inspeccion.estado) !== 1;

    Swal.fire({
      icon: 'warning',
      title: `${activar ? 'Activar' : 'Inactivar'} inspección`,
      text: `¿Está seguro de ${activar ? 'activar' : 'inactivar'} esta inspección?`,
      showCancelButton: true,
      confirmButtonText: `Sí, ${activar ? 'activar' : 'inactivar'}`,
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    }).then((resultado) => {
      if (!resultado.isConfirmed) return;

      const accion$ = activar
        ? this.inspeccionesService.activar(inspeccion.id as number)
        : this.inspeccionesService.inactivar(inspeccion.id as number);
      accion$.subscribe({
        next: () => {
          Swal.fire({
            icon: 'success',
            title: activar ? 'Inspección activada' : 'Inspección inactivada',
            text: `La inspección fue ${activar ? 'activada' : 'inactivada'} correctamente.`,
            timer: 1600,
            showConfirmButton: false,
          });
          this.cargarInspecciones();
        },
        error: () => this.toastError(`No se pudo ${activar ? 'activar' : 'inactivar'} la inspección.`),
      });
    });
  }

  // Devuelve el id como number (o null) aunque el backend lo envíe como
  // string ("3") o como objeto anidado ({ id: 3, ... }).
  private idCatalogo(valor: any): number | null {
    const id = valor != null && typeof valor === 'object'
      ? (valor.id ?? valor.codigo)
      : valor;
    if (id === null || id === undefined || id === '') return null;
    const numero = Number(id);
    return Number.isFinite(numero) ? numero : null;
  }

  // ===== Fechas =====

  private hoy(): string {
    const fecha = new Date();
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getDate()).padStart(2, '0');
    return `${fecha.getFullYear()}-${mes}-${dia}`;
  }

  private normalizarFecha(fecha: any): string | null {
    if (!fecha) return null;
    const valor = String(fecha);
    if (/^\d{4}-\d{2}-\d{2}/.test(valor)) return valor.slice(0, 10);
    const convertida = new Date(fecha);
    if (Number.isNaN(convertida.getTime())) return null;
    const mes = String(convertida.getMonth() + 1).padStart(2, '0');
    const dia = String(convertida.getDate()).padStart(2, '0');
    return `${convertida.getFullYear()}-${mes}-${dia}`;
  }

  formatearFecha(fecha: any): string {
    const valor = this.normalizarFecha(fecha);
    if (!valor) return '';
    const [anio, mes, dia] = valor.split('-');
    return `${dia}/${mes}/${anio}`;
  }

  // ===== Formulario =====

  private valoresIniciales(): any {
    return {
      estado: 1,
      fecha_inspeccion: this.hoy(),
      via_id: this.idCatalogo(this.zonaActual?.via_id),
      zona_id: this.zonaId,
    };
  }

  inicializarForm(): void {
    this.form = this.fb.group({
      via_id: [null, Validators.required],
      zona_id: [null, Validators.required],
      riesgo_id: [null],
      codigo: [null, Validators.required],
      tipo_inspeccion: [null, Validators.required],
      motivo: [null],
      fecha_inspeccion: [this.hoy(), Validators.required],
      inspector_id: [null],
      condiciones_climaticas: [null],
      condiciones_operacion: [null],
      resultado: [null],
      observaciones: [null],
      estado: [1],
    });
  }

  // ===== Guardado =====

  guardar(continuar = false): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      const camposInvalidos = Object.keys(this.form.controls)
        .filter((campo) => this.form.get(campo)?.invalid)
        .join(', ');
      Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: `Revisa los siguientes campos: ${camposInvalidos}.`,
      });
      return;
    }

    const payload: PesvViasInspeccionesPayload = this.form.getRawValue();
    this.guardando = true;

    const peticion$ = this.idInspeccion
      ? this.inspeccionesService.update(this.idInspeccion, payload)
      : this.inspeccionesService.create(payload);

    peticion$.subscribe({
      next: () => this.finalizarGuardado(continuar),
      error: (err) => {
        this.guardando = false;
        this.toastError(err?.error?.message ?? err?.error?.error ?? 'Ocurrió un error al guardar la inspección.');
      },
    });
  }

  private finalizarGuardado(continuar: boolean): void {
    this.guardando = false;
    Swal.fire({
      icon: 'success',
      title: this.idInspeccion ? 'Inspección actualizada' : 'Inspección registrada',
      text: 'La información se guardó correctamente.',
      timer: 1800,
      showConfirmButton: false,
    });

    if (continuar && !this.idInspeccion) {
      this.form.reset(this.valoresIniciales());
    } else {
      this.cargarInspecciones();
      this.editando = false;
      this.idInspeccion = null;
      this.form.reset(this.valoresIniciales());
      this.activeTab = 2;
    }
  }

  guardarYContinuar(): void {
    this.guardar(true);
  }

  cancelar(): void {
    this.nuevaInspeccion();
    this.activeTab = 2;
    this.cargarInspecciones();
  }

  private toastError(mensaje: string): void {
    Swal.fire({ icon: 'error', title: 'Error', text: mensaje });
  }

  exportarExcel(): void {
    Utils.exportVisibleTableToExcel(
      'tblViasInspecciones',
      'listado_vias_inspecciones',
      'Inspecciones de vías',
    );
  }

  exportarPdf(): void {
    Utils.exportToPDF(
      'tblViasInspecciones',
      'listado_vias_inspecciones',
      'Listado de inspecciones de vías',
      true,
    );
  }

    verHallazgos(inspeccion: PesvViasInspecciones): void {
      if (!inspeccion.id) return;
      this.router.navigate(['listado/vias-hallazgos', inspeccion.id]);
    }
}